import React from 'react';
import Reveal from '../../components/reveal';
import Hero from './hero';
import Trailer from './trailer';
import Gallery from './gallery';
import Faq from './faq';
import { FEATURES } from './content';
import './home.css';

export default function Home() {
  return (
    <>
      <Hero />

      <section className="section section--band" id="the-game">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">The game</span>
            <h2 className="section-heading">There&apos;s only one fire.</h2>
          </Reveal>

          <ul className="feature-grid">
            {FEATURES.map(({ title, body }, index) => (
              <Reveal as="li" key={title} className="feature" delay={(index % 3) * 70}>
                <h3>{title}</h3>
                <p>{body}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section className="section trailer-section" id="trailer">
        <div className="shell">
          <Reveal>
            <h2 className="section-heading">Trailer</h2>
          </Reveal>
          <Reveal delay={90}>
            <Trailer />
          </Reveal>
        </div>
      </section>

      <section className="section" id="screens">
        <div className="shell">
          <Reveal>
            <h2 className="section-heading">Screenshots</h2>
          </Reveal>
          <Reveal delay={80}>
            <Gallery />
          </Reveal>
        </div>
      </section>

      <section className="section section--band" id="faq">
        <div className="shell faq-section">
          <Reveal className="faq-section__intro">
            <h2 className="section-heading">FAQ</h2>
          </Reveal>
          <Reveal delay={80}>
            <Faq />
          </Reveal>
        </div>
      </section>
    </>
  );
}
